<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Skins
        <small>accept or decline skins</small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <form class="col-sm-6">

          <div class="form-group">
            <input type="text" class="form-control" placeholder="Search..." @keyup="skinSearchDB();" v-model="skinSearch">
          </div>
        </form>

      </div>


      <div class="row">
        <div class="ui six stackable cards" id="skins-cards"  v-if="skins.images.length">
          <div :class="'col-sm-6 col-md-4 card col-lg-' + bigScreenSkins" :data-skin-id="item.id" v-for="item in skins.visible_images">
              <img class="card-img-top" :src="baseUrl2 + '/public/images/skins_pre/'+item.skin_name+'.png'">
              <div class="card-block">

                <div class="card-text">
                  <span v-if="role >= 33">{{ item.ip }}</span>
                </div>
              </div>
              <div class="card-footer">
                <h4 class="text-center card-title mt-3">{{ item.skin_name }}</h4>
                <div class="card-text">
                  {{ item.additional_info }}
                </div>

                <button @click="removeSkinDB(item.id, item.skin_name)" class="btn btn-danger btn-sm">Delete</button>
                <button @click="approveSkin(item.skin_name)" class="btn btn-success pull-right btn-sm">Approve</button>
              </div>
          </div>
        </div>



      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Waiting',

    data: function () {
      return {
        baseUrl2: 'https://agar.rs',
        loading: true,
        rename: false,
        skins: new Form({
          images: [],
          visible_images: [],
          skin_name: ''
        }),
        skinSearch: '',
        isActiveSearch: false,
        scrollCalled: 0,
        isLoadingNew: false,
        role: 1,
        bigScreenSkins: 3

      }
    },
    methods: {
      getSkinsDB: function () {
        var self = this
        this.skins.post(baseUrl + 'Skins/getWaitingSkinList').then(function (result) {
          self.skins.images = result.list
          self.skins.visible_images = result.list
          self.$store.commit('SET_SKINS', Number(result.list.length))
          self.loading = false
        }, function (reason) {
          // rejection
        })
      },
      skinSearchDB: function () {
        var self = this
        if (this.skinSearch.length === 0) {
          this.skins.visible_images = this.skins.images.slice()
        }
        if (this.skinSearch.length > 2) {
          this.isActiveSearch = true
          var data = {}
          data['term'] = this.skinSearch
          this.skins.visible_images = []
          this.skins.post(baseUrl + 'Skins/searchSkin', data).then(function (result) {
            if (result.status === 1) {
              self.skins.visible_images = result.list.slice()
              self.isActiveSearch = false
            }
          }, function (reason) {
            // rejection
          })
        }
      },
      // Admin functions
      renameSkinDB: function (oldname, meta) {
        var name = $(meta).prev('input').val()
        var data = {
          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'name': name,
          'oldname': oldname
        }

        this.skins.post(baseUrl + 'Skins/renameSkin', data).then(function (result) {
          if (result.status === 1) {
          }
          // error
          if (result.status !== 1) {
            alert('Greska. Ime verovatno postoji. Probaj drugo ime')
          }
        }, function (reason) {
        })
      },

      removeSkinDB: function (item, name) {
        var self = this
        var data = {
//          'user_id': localStorage.user_id,
//          'token_header': localStorage.token_header,
//          'token_log': localStorage.token_log,
          'id': item,
          'name': name
        }
        console.log(data)
        this.skins.post(baseUrl + 'Skins/declineSkin', data).then(function (result) {
          if (result.status === 1) {
            self.skins.visible_images.find((o, i) => {
              if (o.skin_name === name) {
                if (i >= 0) {
                  self.skins.visible_images.splice(i, 1)
                  self.$store.commit('SET_SKINS', self.$store.state.waitSkins - 1)
                  return 0
                }
              }
            })
          } else {
            alert('Skin je vec obrisan')
          }
        }, function (reason) {
          // rejection
        })
      },
      approveSkin: function (item) {
        var self = this
        var data = {
          'by': localStorage.user_id,
//          'token_header': localStorage.token_header,
//          'token_log': localStorage.token_log,
          'name': item
        }
        this.skins.post(baseUrl + 'Skins/acceptSkin', data).then(function (result) {
          if (result.status === 1) {
            self.skins.visible_images.find((o, i) => {
              if (o.skin_name === item) {
                if (i >= 0) {
                  self.skins.visible_images.splice(i, 1)
                  self.$store.commit('SET_SKINS', self.$store.state.waitSkins - 1)
                  return 0
                }
              }
            })
          } else {
            alert('Skin sa tim imenom vec postoji. Promeni ime skina')
          }
        }, function (reason) {
          // rejection
        })
      }
    },
    updated () {

    },
    created: function () {
      if (screen.width > 1500) {
        this.bigScreenSkins = 2
      }
      this.getSkinsDB()
      this.role = this.$store.state.role
    }
  }
</script>

<style scoped>
@media (min-width: 992px) {
  .card-text {
    min-height: 30px;
  }
  .col-md-4 {

  }

}
@media (min-width: 1200px) {
  .col-lg-3 {

  }
}


</style>



// WEBPACK FOOTER //
// Waiting.vue?1b778de3